import React from 'react'

import 'react-vis/dist/style.css'

import {
  RadarChart,
  makeWidthFlexible
} from 'react-vis'

const DATA = [
  { name: 'IN8015', nightvision: 10, megapixel: 2, power: 8, focal: 4.2, irleds: 10 },
  { name: 'IN6012', nightvision: 10, megapixel: 1, power: 8, focal: 8, irleds: 12 }
]

const FlexibleRadarChart = makeWidthFlexible(RadarChart)

export default class IN8015RadarIN6012 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crosshairValues: []
    };
  }

  render() {
    return (
      <React.Fragment>

        <div className="chart">
          <FlexibleRadarChart
            data={DATA}
            startingAngle={0}
            domains={[
              { name: 'focal', domain: [4, 8] },
              { name: 'megapixel', domain: [1, 2] },
              { name: 'power', domain: [6, 8] },
              { name: 'nightvision', domain: [8, 10] },
              { name: 'irleds', domain: [8, 12] }
            ]}
            margin={{
              left: 50,
              right: 50
            }}
            animation={true}
            width={400}
            height={275} />
        </div>

      </React.Fragment>
    );
  }
}